import React from 'react';
import { Box, Button, Alert, AlertTitle } from '@material-ui/core';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

export default function AlertMessage() {

	const {message} = useParams()

  return (
    <>
      <Alert severity="success" sx={{my:3, width: '100%'}}>
        <AlertTitle>Pedido enviado</AlertTitle>
        Recibimos tu pedido correctamente. Número: <strong>{message}</strong>
      </Alert>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
        <Button component={Link} to="/order" variant="outlined">
          Ver mis pedidos
        </Button>
        <Button component={Link} to="/" variant="contained" color="primary">
          Volver al catálogo
        </Button>
      </Box>
    </>
  );
}
